<template>
  <div class="container">
    <crumb prevLevel="流通数据监管" current="药品流向" />
    <ul class="tab1">
      <li
        :class="['tab1-item', { active: tab1Filter === 'drug_production' }]"
        @click="tab1Click('drug_production')"
      >
        <img
          :src="
            tab1Filter === 'drug_production'
              ? require('assets/images/pro_active.png')
              : require('assets/images/pro.png')
          "
          alt=""
          class="tab1-item-img"
        />
        <span>生产企业</span>
      </li>
      <li
        :class="['tab1-item', { active: tab1Filter === 'buss_drug' }]"
        @click="tab1Click('buss_drug')"
      >
        <img
          :src="
            tab1Filter === 'buss_drug'
              ? require('assets/images/cir_active.png')
              : require('assets/images/cir.png')
          "
          class="tab1-item-img"
          alt=""
        />
        <span>流通企业</span>
      </li>
      <li
        :class="['tab1-item', { active: tab1Filter === 'pharmacy_drug' }]"
        @click="tab1Click('pharmacy_drug')"
      >
        <img
          :src="
            tab1Filter === 'pharmacy_drug'
              ? require('assets/images/retail_active.png')
              : require('assets/images/retail.png')
          "
          class="tab1-item-img"
          alt=""
        />
        <span>零售企业</span>
      </li>
    </ul>
    <ul class="tab2">
      <li
        :class="['tab2-item', { active: tab2Filter === 'income_info' }]"
        @click="tab2Click('income_info')"
      >
        药品入库
      </li>
      <li
        :class="['tab2-item', { active: tab2Filter === 'out_info' }]"
        @click="tab2Click('out_info')"
      >
        药品销售
      </li>
      <li
        :class="['tab2-item', { active: tab2Filter === 'stock_info' }]"
        @click="tab2Click('stock_info')"
      >
        药品库存
      </li>
    </ul>
    <div class="search">
      <el-form label-width="110px">
        <el-row>
          <el-col :span="6" v-if="tab2Filter !== 'stock_info'">
            <el-form-item label="发货方">
              <el-input
                placeholder="请输入发货方"
                v-model="queryParams.sender"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="tab2Filter !== 'stock_info' ? '接收方' : '库存企业名称'"
            >
              <el-input
                placeholder="请输入接收方"
                v-model="queryParams.receiver"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="药品通用名称">
              <el-input
                placeholder="请输入通用药品名称"
                v-model="queryParams.productName"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="药品批准文号">
              <el-input
                placeholder="请输入药品批准文号"
                v-model="queryParams.approvalNumber"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="药品生产企业">
              <el-input
                placeholder="请输入药品生产企业"
                v-model="queryParams.productEntName"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="生产批号">
              <el-input
                placeholder="请输入生产批号"
                v-model="queryParams.batchNumber"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="规格">
              <el-input
                placeholder="请输入规格"
                v-model="queryParams.drugSpecifications"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="剂型">
              <el-input
                placeholder="请输入剂型"
                v-model="queryParams.dosageForm"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="有效期">
              <el-date-picker
                v-model="validateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="tab2Filter !== 'stock_info'">
            <el-form-item
              :label="tab2Filter === 'income_info' ? '入库时间' : '销售时间'"
            >
              <el-date-picker
                v-model="stockRange"
                type="daterange"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品类型">
              <el-select v-model="queryParams.productType">
                <el-option label="全部" value="" />
                <el-option label="药品" value="1" />
                <el-option label="器械" value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="0">
              <el-button type="primary" style="margin-left:20px" @click="init"
                >查询</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="statistic">
      <div class="title">
        {{
          tab2Filter === 'income_info'
            ? '药品入库'
            : tab2Filter === 'out_info'
            ? '药品销售'
            : '药品库存'
        }}数量统计
      </div>
      <div class="content">
        <div class="num-list">
          <div class="num-item">
            <div class="num">{{ entNum }}</div>
            <div class="text">{{ enterpriseType }}企业数量</div>
          </div>
          <div class="num-item">
            <div class="num">{{ flowNum }}</div>
            <div class="text">
              {{
                tab2Filter === 'income_info'
                  ? '药品入库'
                  : tab2Filter === 'out_info'
                  ? '药品销售'
                  : '药品库存'
              }}数量（最小包装单位）
            </div>
          </div>
        </div>
        <Echarts :echartsOption="echartsOption" echartsHeight="400px" />
      </div>
    </div>
    <div class="table-list">
      <div class="title">{{ listTitle }}</div>
      <el-table :data="drugList" class="table">
        <el-table-column
          prop="documentNo"
          label="单据号"
          v-if="tab2Filter !== 'stock_info'"
        />
        <el-table-column
          :prop="tab2Filter === 'income_info' ? 'receivingUnit' : 'entName'"
          label="发货方"
          v-if="
            tab2Filter !== 'stock_info' &&
              !(
                tab2Filter === 'income_info' && tab1Filter === 'drug_production'
              )
          "
        />
        <el-table-column
          :prop="tab2Filter !== 'out_info' ? 'entName' : 'receivingUnit'"
          :label="tab2Filter !== 'stock_info' ? '接收方' : '库存企业名称'"
          v-if="
            !(tab2Filter === 'income_info' && tab1Filter === 'drug_production')
          "
        />
        <el-table-column prop="productName" label="药品通用名称" />
        <el-table-column prop="approvalNumber" label="药品批准文号" />
        <el-table-column prop="dosageForm" label="剂型" />
        <el-table-column prop="drugSpecifications" label="规格" />
        <el-table-column prop="productEntName" label="药品生产企业" />
        <el-table-column prop="batchNumber" label="生产批号" />
        <el-table-column prop="validityTime" label="有效期" />
        <el-table-column
          prop="issuanceDate"
          :label="tab2Filter === 'income_info' ? '入库日期' : '销售日期'"
          v-if="tab2Filter !== 'stock_info'"
        />
        <el-table-column
          prop="number"
          :label="
            tab2Filter === 'income_info'
              ? '入库数量（最小包装单位）'
              : tab2Filter === 'out_info'
              ? '销售数量（最小包装单位）'
              : '库存数量（最小包装单元）'
          "
        />
      </el-table>
      <el-pagination
        class="pagination"
        layout="total, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="currentPage"
        :page-size="5"
        @current-change="loadTabelData"
      />
    </div>
  </div>
</template>

<script>
import Echarts from 'components/echarts/echarts';
import Crumb from 'components/crumb/crumb';

export default {
  data() {
    return {
      tab1Filter: 'drug_production',
      tab2Filter: 'income_info',
      validateRange: '',
      stockRange: '',
      queryParams: {
        sender: '',
        receiver: '',
        productName: '',
        approvalNumber: '',
        productEntName: '',
        batchNumber: '',
        drugSpecifications: '',
        dosageForm: '',
        productType: ''
      },
      entNum: '',
      flowNum: '',
      enterpriseType: '生产',
      echartsOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              show: false,
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: 30,
              textStyle: {
                color: '#666'
              }
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(206,219,239,0.5)'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#999'
              }
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(206,219,239,0.5)'
              }
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(206,219,239,0.5)'
              }
            }
          }
        ],
        series: [
          {
            type: 'bar',
            barWidth: '27px',
            itemStyle: {
              color: '#386CE2'
            },
            data: []
          }
        ]
      },
      drugList: [],
      currentPage: 1,
      total: 0
    };
  },
  computed: {
    listTitle() {
      let title = '';
      if (this.tab2Filter === 'income_info') {
        title = '药品入库列表';
      } else if (this.tab2Filter === 'out_info') {
        title = '药品销售列表';
      } else if (this.tab2Filter === 'stock_info') {
        title = '药品库存';
      }
      return title;
    },
    tableName() {
      return `${this.tab1Filter}_${this.tab2Filter}`;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    tab1Click(type) {
      this.tab1Filter = type;
      this.tab2Filter = 'income_info';
      this.resetQueryParams();
      this.init();
    },
    tab2Click(type) {
      this.tab2Filter = type;
      this.resetQueryParams();
      this.init();
    },
    resetQueryParams() {
      this.queryParams = {
        entName: '',
        productName: '',
        approvalNumber: '',
        batchNumber: '',
        drugSpecifications: '',
        dosageForm: '',
        productType: ''
      };
    },
    init() {
      this.loadEchartsData();
      this.loadTabelData(1);
    },
    loadEchartsData() {
      const validateRange = this.validateRange;
      const stockRange = this.stockRange;
      this.$request({
        url: 'rest/production/flowNumStatics',
        data: {
          json: JSON.stringify({
            pageBean: { pageBean: 1, pageSize: 10000 },
            params: {
              ...this.queryParams,
              validTimeStart: validateRange ? validateRange[0] : '',
              validTimeEnd: validateRange ? validateRange[1] : '',
              collectGoodsStart: stockRange ? stockRange[0] : '',
              collectGoodsEnd: stockRange ? stockRange[1] : '',
              tableName: this.tableName
            }
          })
        }
      }).then(res => {
        if (this.tab1Filter === 'drug_production') {
          this.enterpriseType = '生产';
        }
        if (this.tab1Filter === 'buss_drug') {
          this.enterpriseType = '流通';
        }
        if (this.tab1Filter === 'pharmacy_drug') {
          this.enterpriseType = '零售';
        }
        this.entNum = res.entNum || 0;
        this.flowNum = res.flowNum || 0;
        const xData = [];
        const yData = [];
        res.list.forEach(item => {
          xData.push(item.ent_name);
          yData.push(item.flow_number);
        });
        this.echartsOption.xAxis[0].data = xData;
        this.echartsOption.series[0].data = yData;
      });
    },
    loadTabelData(currentPage) {
      this.currentPage = currentPage;
      let type = '';
      let url = '';
      let receivingUnit = '';
      let entName = '';
      if (this.tab2Filter === 'income_info') {
        type = '0';
        receivingUnit = this.queryParams.sender;
        entName = this.queryParams.receiver;
      } else if (this.tab2Filter === 'out_info') {
        type = '2';
        receivingUnit = this.queryParams.receiver;
        entName = this.queryParams.sender;
      } else if (this.tab2Filter === 'stock_info') {
        type = '1';
        entName = this.queryParams.receiver;
      }

      if (this.tab1Filter === 'drug_production') {
        url = 'entbaseinfo/entList';
      }
      if (this.tab1Filter === 'buss_drug') {
        url = 'entbaseinfo/bussList';
      }
      if (this.tab1Filter === 'pharmacy_drug') {
        url = 'entbaseinfo/pharmacyList';
      }
      const validateRange = this.validateRange;
      const stockRange = this.stockRange;
      this.$request({
        url,
        data: {
          pageNum: this.currentPage,
          pageSize: 5,
          ...this.queryParams,
          receivingUnit,
          entName,
          validTimeStart: validateRange ? validateRange[0] : '',
          validTimeEnd: validateRange ? validateRange[1] : '',
          collectGoodsStart: stockRange ? stockRange[0] : '',
          collectGoodsEnd: stockRange ? stockRange[1] : '',
          type
        }
      }).then(res => {
        this.total = res.pageInfo.total;
        this.drugList = res.pageInfo.list;
      });
    }
  },
  components: {
    Echarts,
    Crumb
  }
};
</script>

<style lang="stylus" scoped>
@import './common.styl'
.tab1
  line-height 60px
  border-bottom 1px solid rgba(206,219,239,0.5)
  display flex
  .tab1-item
    padding 0 20px
    display flex
    align-items center
    border-right 1px solid rgba(206,219,239,0.5)
    cursor pointer
    &.active
      color #386ce2
    .tab1-item-img
      width 18px
      margin-right 10px
.tab2
  line-height 30px
  background #ddd
  display inline-block
  margin-top 20px
  .tab2-item
    padding 0 20px
    color #aaa
    cursor pointer
    display inline-block
    font-size 14px
    &.active
      background #386ce2
      color #fff
.info-container
  display flex
  justify-content left
  padding 20px 0
  .item
    width 610px
    border 1px solid rgba(206,219,239,0.5)
    margin-left 45px
    font-size 12px
    display flex
    line-height 20px
    .name
      background rgba(247,249,254,1)
      width 140px
      text-align center
      padding 12px 0
      div
        margin-bottom 8px
    .ins
      flex 1
      color #666666
      padding 12px 0
      margin-left 20px
      div
        margin-bottom 8px
</style>
